import { MotionValue, m, useTransform } from 'framer-motion';
// @mui
import { Box } from '@mui/material';
//
import { STAGE, TT } from '../../../theme/stage';
import BisqueRing from '../primitives/BisqueRing';

// ----------------------------------------------------------------------

export type ArtProps = {
  fan: MotionValue<number>;
  animated: boolean;
};

type TagProps = ArtProps & {
  fill: string;
  rest: number;
  spread: number;
};

const TAG_PATH = 'M32 5H68L95 32V155H5V32ZM38 26a12 12 0 1 0 24 0a12 12 0 1 0-24 0Z';

const TAGS = [
  { fill: TT.lighter, rest: 11, spread: 3 },
  { fill: TT.light, rest: 2, spread: 0 },
  { fill: TT.main, rest: -8, spread: -3 },
];

const STRING_PATH = 'M196 78C182 50 194 22 212 -4M204 78C212 52 222 26 230 -4';

const FILL = { position: 'absolute', inset: 0, width: '100%', height: '100%' } as const;

const FIELD = `linear-gradient(180deg, ${TT.field}, ${TT.fieldDeep})`;

function Tag({ fan, animated, fill, rest, spread }: TagProps) {
  const rotate = useTransform(fan, (v) => rest + spread * v);

  return (
    <m.div
      style={{
        position: 'absolute',
        left: '35%',
        top: '15.6%',
        width: '30%',
        aspectRatio: '5 / 8',
        transformOrigin: '50% 16.25%',
        willChange: animated ? 'transform' : undefined,
        rotate,
      }}
    >
      <Box
        component="svg"
        viewBox="0 0 100 160"
        sx={{
          display: 'block',
          width: '100%',
          height: '100%',
          filter: 'drop-shadow(0 2px 3px rgba(3, 9, 26, .45))',
        }}
      >
        <path
          d={TAG_PATH}
          fill={fill}
          fillRule="evenodd"
          stroke={fill}
          strokeWidth={10}
          strokeLinejoin="round"
        />
      </Box>
    </m.div>
  );
}

export default function TondTondArt({ fan, animated }: ArtProps) {
  return (
    <>
      <Box sx={{ ...FILL, backgroundImage: FIELD }} />

      {TAGS.map((tag) => (
        <Tag key={tag.fill} fan={fan} animated={animated} {...tag} />
      ))}

      <Box component="svg" viewBox="0 0 400 300" sx={FILL}>
        <path
          d={STRING_PATH}
          fill="none"
          stroke={STAGE.bisqueShade}
          strokeWidth={1}
          strokeLinecap="round"
          vectorEffect="non-scaling-stroke"
        />
      </Box>

      <Box
        sx={{
          position: 'absolute',
          left: '50%',
          top: '26%',
          width: '7.2%',
          aspectRatio: '1',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <BisqueRing size="art" />
      </Box>
    </>
  );
}
